import { Context, CustomQuery } from '@vue-storefront/core';
import { ApiResult, OrderItem, Order } from '../../types';
// , OrderItem, Order
// 订单列表
export default async function orderDetail(context: Context, params: CustomQuery): Promise<ApiResult> {
  const url = new URL('/mall/order/detail', context.config.api.url);
  const { data: res } = await context.client.post(url.href, params, { timeout: 30000 });
  if (res.code === 0) {
    const order = res.data;
    if (order.order_id) {
      const orderDetail: Order = {
        orderId: order.order_id,
        shopId: order.shopId,
        memberId: order.member_id,
        totalCount: order.total_count,
        discount: order.discount,
        postFee: order.post_fee,
        taxFee: order.tax_fee,
        payment: order.payment,
        activityInfo: order.activity_info,
        userNote: order.user_note,
        memberNote: order.member_note,
        fromId: order.from_id,
        fxId: order.fx_id,
        payWayId: order.pay_way_id,
        status: order.status,
        pickupOrder: order.pickup_order,
        addressId: order.address_id,
        createTime: order.create_time,
        orderItem: [],
        combined: order.combined,
        transCurrency: order.trans_currency,
        transAmount: order.trans_amount,
        postFeeTax: order.post_fee_tax,
        insuranceFee: order.insurance_fee,
        insuranceTax: order.insurance_tax,
        city: order.city,
        street: order.street,
        apartment: order.apartment,
        zipCode: order.zip_code,
        phone: order.phone,
        lastName: order.last_name,
        firstName: order.first_name,
        country: order.country,
        state: order.state,
        logisticsName: order.logistics_name,
        shipmentId: order.shipment_id,
        serviceOrder: order.service_order,
        currency: order.currency,
      };
      if (order && order.order_item) {
        // 循环list
        order.order_item.forEach((x) => {
          const item: OrderItem = {
            orderId: x.order_id,
            shopId: x.shop_id,
            goodId: x.good_id,
            skuId: x.sku_id,
            num: x.num,
            price: x.price,
            discount: x.discount,
            totalPayment: x.total_payment,
            activityInfo: x.activity_info,
            title: x.title,
            imgUrl: x.img_url,
            skuProp: x.sku_prop,
            isGift: x.is_gift,
            taxFee: x.tax_fee
          };
          orderDetail.orderItem.push(item);
        });
      }
      res.data = orderDetail;
    }
  }
  return res;
}
